export let OAuthProviders;
(function (OAuthProviders) {
  OAuthProviders["Microsoft"] = "microsoft";
  OAuthProviders["Google"] = "google";
  OAuthProviders["Apple"] = "apple";
})(OAuthProviders || (OAuthProviders = {}));
export const OAuthStyles = {
  [OAuthProviders.Google]: {
    bgColor: '#1a73e8',
    borderColor: '#1a73e8',
    textColor: '#ffffff',
    hoverBgColor: '#1a73e8'
  },
  [OAuthProviders.Microsoft]: {
    bgColor: '#2f2f2f',
    borderColor: '#2f2f2f',
    textColor: '#ffffff',
    hoverBgColor: '#4d4d4d'
  },
  [OAuthProviders.Apple]: {
    bgColor: '#ffffff',
    borderColor: '#000000',
    textColor: '#000000',
    hoverBgColor: '#eeeeee'
  }
};